import type { ReactNode } from 'react'
import React from 'react'

import * as S from './ReportTooltip.styled'

type ReportTooltipProps = {
  content: ReactNode
}

export const ReportTooltip = ({ content }: ReportTooltipProps) => {
  return <S.Container>{content}</S.Container>
}
